<template>
	<section>
		<div class="pcMaxW imgContainer">
			<img :src="banner" />
			
			<section class="pt-5">
				<div class="pcMaxW bgDark p-5 container">
					<div class="dFlex alCenter jcBetween title mb-3">
						<h5 class="m-0 fw-normal">關於我們</h5>
					</div>
					<div class="textWhite50">
						<p class="mb-3">
						Pomelo Co., Limited，總部位於國際金融中心——香港，是一家集研發、製造、發行與全球貿易於一體的多元化國際企業。
						</p><p class="mb-2">公司自創立以來，始終秉持「品質為本，創新驅動，誠信共贏」的經營理念，專注於數位娛樂產業，涵蓋手機遊戲、網路遊戲、跨平台互動娛樂產品的開發與全球推廣。我們擁有專業的技術研發團隊及具國際視野的市場營運團隊，致力於為全球用戶提供高品質、多元化的數位娛樂體驗。
						</p><p class="mb-2">同時，Pomelo Co., Limited 積極拓展國際合作，業務遍佈亞洲、歐洲、北美、南美及中東等多個地區，與眾多全球知名企業建立了長期穩定的合作夥伴關係。
						</p><p class="mb-2">展望未來，我們將持續加大研發投入，擁抱最新科技，優化產品品質，拓展更廣闊的國際市場，攜手全球合作夥伴共同開創數位娛樂新格局。
						</p><p class="mb-2">Pomelo Co., Limited
						</p><p class="mb-2">—— 讓創意點亮未來，讓娛樂連接世界。
						</p>
					</div>
				</div>
			</section>
		</div>
	</section>
	
</template>

<script setup>
	import { ref,onMounted,getCurrentInstance } from 'vue'
	const banner = ref(require('@/assets/images/hongkong_000.png'))
</script>

<style lang="less" scoped>
	.imgContainer{
		overflow: hidden;position: relative;
		img{
			width: 100%;vertical-align: middle;border-radius: 23px;
		}
	}
</style>